import {
  FETCH_BY_TEMPLATE_ID__ERROR,
  FETCH_BY_TEMPLATE_ID__REQUEST,
  FETCH_BY_TEMPLATE_ID__SUCCESS,
  FETCH_ALL__ERROR,
  FETCH_ALL__SUCCESS,
  FETCH_ALL__REQUEST,
  FETCH_VISIBLE_OVERVIEW__ERROR,
  FETCH_VISIBLE_OVERVIEW__REQUEST,
  FETCH_VISIBLE_OVERVIEW__SUCCESS,
  BULK_FETCH_BY_TEMPLATE_IDS__ERROR,
  BULK_FETCH_BY_TEMPLATE_IDS__REQUEST,
  BULK_FETCH_BY_TEMPLATE_IDS__SUCCESS,
  SET_VISIBLE_OVERVIEW_TEMPLATES,
  UPDATE_TEMPLATES_ORDER,
} from "./actionTypes";
import { TemplatesActions, TemplateMetadataStoreSlice } from "./types";

import byId from "./subreducers/singleTemplate/byId";
import allTemplatesReducer from "./subreducers/allTemplates/allTemplates";
import visibleOverviewTemplatesReducer from "./subreducers/visibleOverviewTemplates/visibleOverviewTemplates";

const initialState: TemplateMetadataStoreSlice = {
  byId: {},
  visibleOverviewIds: [],
  isFetchingAll: false,
};

const reducer = (state = initialState, action: TemplatesActions) => {
  switch (action.type) {
    case BULK_FETCH_BY_TEMPLATE_IDS__ERROR:
    case BULK_FETCH_BY_TEMPLATE_IDS__REQUEST:
    case BULK_FETCH_BY_TEMPLATE_IDS__SUCCESS:
    case FETCH_ALL__ERROR:
    case FETCH_ALL__SUCCESS:
    case FETCH_ALL__REQUEST:
    case UPDATE_TEMPLATES_ORDER:
      return allTemplatesReducer(state, action);

    case FETCH_VISIBLE_OVERVIEW__ERROR:
    case FETCH_VISIBLE_OVERVIEW__SUCCESS:
    case FETCH_VISIBLE_OVERVIEW__REQUEST:
      return visibleOverviewTemplatesReducer(state, action);

    case FETCH_BY_TEMPLATE_ID__ERROR:
    case FETCH_BY_TEMPLATE_ID__REQUEST:
    case FETCH_BY_TEMPLATE_ID__SUCCESS:
      return {
        ...state,
        byId: byId(state.byId, action),
      };
    case SET_VISIBLE_OVERVIEW_TEMPLATES:
      return {
        ...state,
        visibleOverviewIds: action.payload.ids,
      };
    default:
      return state;
  }
};

export default reducer;
